<template>
  <div>
    <iModal
      :title="modelTitle"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="130"
            @submit.native.prevent
          >
            <FormItem label="语言：" prop="typeLanguage">
              <Select v-model="formInline.typeLanguage" placeholder="请选择">
                <Option
                  v-for="item in languageList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                ></Option>
              </Select>
            </FormItem>

            <FormItem label="展区名称：" prop="name">
              <Input v-model="formInline.name" placeholder="请输入" />
            </FormItem>
            <FormItem label="对应展区：" prop="thirdPartyZoneId">
              <!-- <Input v-model="formInline.thirdPartyZoneId" /> -->
              <Select v-model="formInline.thirdPartyZoneId" placeholder="请选择">
                <Option
                  v-for="item in correspondArea"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></Option>
              </Select>
            </FormItem>

            <FormItem :label="formInline.typeLanguage == '中文' ? '光地价格：' : 'RMB：'" prop="zonePrice">
              <InputNumber
                :max="99999999"
                :min="0"
                v-model="formInline.zonePrice"
              ></InputNumber
              >/㎡
            </FormItem>
            <FormItem :label="formInline.typeLanguage == '中文' ? '标摊价格：' : 'USD：'" prop="zonePcount">
              <InputNumber
                :max="99999999"
                :min="0"
                v-model="formInline.zonePcount"
              ></InputNumber
              >/个（9㎡）
            </FormItem>

            <FormItem label="排序：" prop="showIndex">
              <InputNumber
                :max="99999999"
                :min="-10"
                v-model="formInline.showIndex"
              ></InputNumber>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')"
          >确定</Button
        >
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  // 新增展馆modal
  name: "pavilion-add",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
    },
    modelTitle: {
      type: String,
    },
    correspondArea: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      showModal: false,
      time: [],
      editId: "",
      formInline: {
        // form双向绑定
        name: "",
        thirdPartyZoneId: "",
        showIndex: 0,
        zonePrice: 0,
        zonePcount: 0,
        typeLanguage: "中文",
      },
      ruleInline: {
        name: [{ required: true, message: "展区名称不能为空", trigger: "change" }],
        thirdPartyZoneId: [
          { required: true, message: "对应展区不能为空", trigger: "change" },
        ],
        typeLanguage: [{ required: true, message: "语言不能为空", trigger: "change" }],
        zonePrice: [{ required: true, message: "光地价格不能为空" }],
        zonePcount: [{ required: true, message: "标摊价格不能为空" }],
        showIndex: [{ required: true, message: "排序不能为空" }],
      },
      languageList: [
        {
          id: 0,
          name: "中文",
        },
        {
          id: 1,
          name: "英文",
        },
      ],
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    options(val) {
      if (val.msg) {
        // 编辑
        this.formInline.name = val.msg.name;
        this.formInline.showIndex = val.msg.showIndex;
        this.formInline.thirdPartyZoneId = val.msg.thirdPartyZoneId;
        this.formInline.zonePrice = val.msg.zonePrice;
        this.formInline.zonePcount = val.msg.zonePcount;
        this.formInline.typeLanguage = val.msg.typeLanguage;

        this.editId = val.msg.id;
      }
    },
  },
  created() {},
  methods: {
    ...mapActions({
      PjNameGroupPut: "hostSetModule/PjNameGroupPut",

      PjNameGroupPost: "hostSetModule/PjNameGroupPost",
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      this.loading = true;
      if (this.options.model) {
        // 编辑模式
        let req = {
          Id: this.editId,
          SetValues: {
            Name: form.name,
            ThirdPartyZoneId: form.thirdPartyZoneId,
            ThirdPartyZoneName: this.correspondArea.find(
              (item) => item.id == form.thirdPartyZoneId
            ).name,
            TypeLanguage: form.typeLanguage,
            ZonePrice: form.zonePrice,
            ZonePcount: form.zonePcount,
            ShowIndex: form.showIndex,
          },
        };
        let bool = await this.PjNameGroupPut(req).catch((err) => {
          this.loading = false;
        });
        if (!bool) {
          this.loading = false;
          this.$Message.error("操作失败，请重新尝试");
        } else {
          this.$emit("finish");
          this.$Message.success("操作成功！");
          this.cancel();
          this.loading = false;
        }
      } else {
        // 新增模式
        let req = {
          ExhibitionId: this.exhibitionInfo.id,
          Name: form.name,
          ThirdPartyZoneId: form.thirdPartyZoneId,
          ThirdPartyZoneName: this.correspondArea.find(
            (item) => item.id == form.thirdPartyZoneId
          ).name,
          TypeLanguage: form.typeLanguage,
          ZonePrice: form.zonePrice,
          ZonePcount: form.zonePcount,
          ShowIndex: form.showIndex,
        };
        let bool = await this.PjNameGroupPost(req).catch((err) => {
          this.loading = false;
        });
        if (!bool) {
          this.loading = false;
          this.$Message.error("操作失败，请重新尝试");
        } else {
          this.$emit("finish");
          this.$Message.success("操作成功！");
          this.cancel();
          this.loading = false;
        }
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
      this.editId = "";
    },
  },
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>
